import { Email } from '@models/email.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const adapter: EntityAdapter<Email> = createEntityAdapter<Email>({
    selectId: email => email.id
});

export interface State extends EntityState<Email> {
    loading: boolean;
    error?: any;
    total: number;
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    error: null,
    total: 0
});
